import { useEffect, useState } from "react";
import "dayjs/locale/el";
import { Bars3Icon } from "@heroicons/react/24/solid";
import { BookOpenIcon, CalendarIcon } from "@heroicons/react/24/outline";
import PublicTalkTitles from "../PublicTalkTitles/PublicTalkTitles";
import SideSheet from "../SideSheet/SideSheet";
import { useUser } from "../../context/UserContext";
import { updateFirebaseToken } from "../../api/users/users";
import { useNavigate } from "@tanstack/react-router";

const years = [
  "2024",
  "2025",
  "2026",
  "2027",
  "2028",
  "2029",
  "2030",
  "2031",
  "2032",
];

export default function NavBar() {
  const [openTitles, setOpenTitles] = useState(false);
  const [openSideSheet, setOpenSideSheet] = useState(false);
  const { user, handleLogout, selectedYear, setSelectedYear } = useUser();
  const navigate = useNavigate();
  const [notificationStatus, setNotificationStatus] = useState("Not Supp.");

  useEffect(() => {
    getPermission().then((status) => setNotificationStatus(status));
    // eslint-disable-next-line
  }, []);

  const getPermission = async () => {
    if (!user?.isNotificationsSupported) {
      return "Not Supp.";
    }
    const permission = Notification.permission;
    if (permission === "granted") {
      return "On";
    } else {
      return "Off";
    }
  };

  const handleSideSheetLogout = async () => {
    if (notificationStatus === "On") {
      await updateFirebaseToken(user?.uid, "");
    }
    await handleLogout();
    setOpenSideSheet(false);
    navigate({ to: "/login", resetScroll: true });
  };

  return (
    <>
      <nav className="bg-gray-800 fixed top-0 left-0 right-0 z-50">
        <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
          <div className="relative flex h-16 items-center justify-between">
            <div className="items-center flex gap-4">
              <select
                value={selectedYear}
                onChange={(event) => setSelectedYear(event.target.value)}
                className="py-2 px-2 block w-full bg-white border-transparent rounded-lg text-sm outline-0 disabled:opacity-50 disabled:pointer-events-none"
              >
                {years.map((item, index) => (
                  <option key={item}>{item}</option>
                ))}
              </select>
            </div>

            <div className="inset-y-0 right-0 flex items-center pr-2 sm:ml-6 sm:pr-0">
              {/* Navigation buttons */}
              <div className="inline-flex items-center gap-3">
                <button
                  onClick={() =>
                    navigate({
                      to:
                        user?.role === "admin" ? "/my-speakers" : "/my-program",
                      resetScroll: true,
                    })
                  }
                  className="text-white p-2 transition-colors"
                >
                  <CalendarIcon className="size-6" />
                </button>
                {user?.role === "admin" && (
                  <button
                    className="text-white p-2 transition-colors"
                    onClick={() => setOpenTitles(true)}
                  >
                    <BookOpenIcon className="size-6" />
                  </button>
                )}

                {/* Avatar button to open side sheet */}
                <button
                  onClick={() => setOpenSideSheet(true)}
                  className="relative flex rounded-full text-sm focus:outline-none"
                >
                  <span className="absolute -inset-1.5" />
                  <Bars3Icon className="w-8 h-8 text-white hover:scale-105 transition-transform" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <PublicTalkTitles open={openTitles} setOpen={setOpenTitles} />
      <SideSheet
        open={openSideSheet}
        setOpen={setOpenSideSheet}
        user={user}
        notificationStatus={notificationStatus}
        onLogout={handleSideSheetLogout}
      />
    </>
  );
}
